import { Text, RadioButton } from '@ui-component-library';

import { SELL_TIMBER_GROT_JA_NEJ_OPTIONS } from '../helpers/sellTimberShared';
import { SellTimberFieldInfo } from './SellTimberFieldInfo.js';

export function GrotJaNejFieldset({ legendId, legend, name, value, onChange, fieldInfo }) {
  return (
    <fieldset className="flex flex-col gap-3 border-0 p-0">
      <legend
        id={legendId}
        className="mb-2 flex w-full max-w-full flex-wrap items-center gap-2 border-0 p-0"
      >
        <Text variant="text-sm/leading-normal/medium" as="span">
          {legend}
        </Text>
        <SellTimberFieldInfo
          title={fieldInfo.title}
          text={fieldInfo.text}
          aria-label={`Information om ${legend}`}
        />
      </legend>
      <div className="flex flex-col gap-3" role="radiogroup" aria-labelledby={legendId}>
        {SELL_TIMBER_GROT_JA_NEJ_OPTIONS.map(({ value: optVal, label }) => (
          <RadioButton
            key={optVal}
            name={name}
            value={optVal}
            checked={value === optVal}
            onClick={(v) => onChange(v)}
          >
            <Text
              variant="text-sm/leading-normal/normal"
              className="min-w-0 flex-1 text-left [overflow-wrap:anywhere]"
            >
              {label}
            </Text>
          </RadioButton>
        ))}
      </div>
    </fieldset>
  );
}
